export const doc_home_es = {
  title: "Documentación de Piper",
  description: `¡Gracias por usar Piper! Acá vas a poder encontrar varios documentos explicando las distintas cosas que podés hacer con esta aplicación. Podés navegar por las distintas páginas usando el índice abajo.
    
`
};
